export default function currencyFormat(value) {
  const numberValue = Number(value);
  if (isNaN(numberValue)) {
    return '₹ 0';
  }
  return `₹ ${numberValue.toLocaleString('en-IN')}`;
}
